module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.7febe26.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.ttf
// module id = 0sle
// module chunks = 0